import React, { Component } from 'react';

import _ from "lodash";
import moment from "moment";
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import CryptoJS from "crypto-js";

import { Dropdown, Form, Popup } from 'semantic-ui-react'

import {countries} from "../common";
import { translate } from "../../addons/Translate";

const currentYear = new Date().getFullYear();
const fromMonth = new Date(currentYear - 100, 0);
const toMonth = moment().toDate();

function YearMonthForm({ date, localeUtils, onChange }) {
  const months = localeUtils.getMonths();

  const years = [];
  for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
    years.push(i);
  }

  const handleChange = function handleChange(e) {
    const { year, month } = e.target.form;
    onChange(new Date(year.value, month.value));
  };

  return (
  	<Form className="DayPicker-Caption" size="small">
  		<Form.Group widths="equal" size="small">
  			<Form.Field control='select' name="year" onChange={handleChange} value={date.getFullYear()}>
  				{years.map(year => (
					<option key={year} value={year}>
						{year}
					</option>
				))}
  			</Form.Field>
  			<Form.Field control='select' name="month" onChange={handleChange} value={date.getMonth()}>
  				{months.map((month, i) => (
					<option key={month} value={i}>
						{month}
					</option>
				))}
  			</Form.Field>
  		</Form.Group>
    </Form>
  );
}

class VerifyPhoneForm extends Component {
	form_field_key = Date.now()+"";

	state = {
		data: {
			first_name: !!this.props.data.first_name ? this.props.data.first_name : "",
			last_name: !!this.props.data.last_name ? this.props.data.last_name : "",
			birthday: !!this.props.data.birthday_u ? moment(this.props.data.birthday_u).format('DD/MM/YYYY') : "",
			birthday_u: !!this.props.data.birthday_u ? this.props.data.birthday_u : "",
			address: !!this.props.data.address ? this.props.data.address : "",
			zip_code: !!this.props.data.zip_code ? this.props.data.zip_code : "",
			city: !!this.props.data.city ? this.props.data.city : "",
			email: !!this.props.data.email ? this.props.data.email : "",
			country: this.props.data.country,
		},
		loading: false,
		// error_server: false,
		// errors_response: {},
		errors: {},

		month: toMonth,
		isOpen: false,
	}

	constructor(props) {
		super(props);
		
		this.handleYearMonthChange = this.handleYearMonthChange.bind(this);
	}

	componentWillReceiveProps(props) {
		this.setState({
			data: {
				first_name: !!props.data.first_name ? props.data.first_name : "",
				last_name: !!props.data.last_name ? props.data.last_name : "",
				birthday: !!props.data.birthday_u ? moment(props.data.birthday_u).format('DD/MM/YYYY') : "",
				birthday_u: !!props.data.birthday_u ? props.data.birthday_u : "",
				address: !!props.data.address ? props.data.address : "",
				zip_code: !!props.data.zip_code ? props.data.zip_code : "",
				city: !!props.data.city ? props.data.city : "",
				email: !!props.data.email ? props.data.email : "",
				country: props.data.country,
			}
		})
	}

	handleYearMonthChange(month) {
		this.setState({ month });
	}

	onChangeCheckErrors(name){
		if(this.state.errors[name] !== undefined) {
			this.setState({
				errors: _.omit(this.state.errors, name)
			});
		}
	}

	onChange = e => {
		let name = e.target.name;
		if(name.indexOf('crypto_') !== -1) {
			name = name.replace('crypto_', '');
			name = CryptoJS.AES.decrypt(name, this.form_field_key).toString(CryptoJS.enc.Utf8);
		}

		const data = {...this.state.data, [name]: e.target.value};
		this.props.onUpdate(data);
		this.onChangeCheckErrors(name);
	}

	onChangeCountry(e, {value}) {
		const data = {...this.state.data, country: value};
		this.props.onUpdate(data);
		this.onChangeCheckErrors("country");
	}

	onDateChange(day) {
		const birthday = moment(day);

		const data = {
			...this.state.data,
			birthday: birthday.format('DD/MM/YYYY'),
			birthday_u: birthday.format('YYYY-MM-DD')
		};
		this.props.onUpdate(data);

		this.setState({
			isOpen: false
		});

		this.onChangeCheckErrors("birthday");
	}

	openPopup() {
		this.setState({
			isOpen: true,
			month: this.state.data.birthday_u === "" ? this.state.month : moment(this.state.data.birthday_u).toDate()
		});
	}

	onPopupClose(){
		this.setState({
			isOpen: false
		});
	}

	onSubmit = e => {
		e.preventDefault();
		const errors = this.validate(this.state.data);
		
		this.setState({ errors });

		if(Object.keys(errors).length === 0) {
			this.props.onNextStep("personalInfo");
		}
	}

	validate(data) {
		const errors = {};

		if(!data.first_name) errors.first_name = true;
		if(!data.last_name) errors.last_name = true;
		if(!data.birthday) errors.birthday = true;
		if(!data.address) errors.address = true;
		if(!data.zip_code) errors.zip_code = true;
		if(!data.city) errors.city = true;
		if(!data.country) errors.country = true;
		if(!data.email) errors.email = true;

		return errors;
	}

	render() {
		const { data, errors, loading } = this.state;

		return (
			<Form onSubmit={this.onSubmit.bind(this)} loading={loading}>

				<Form.Group widths="equal">
					<Form.Input
						autoFocus
						placeholder={translate("xxltable.step2.first_name")}
						icon="user"
						iconPosition="left"
						name="first_name"
						value={data.first_name}
						onChange={this.onChange.bind(this)}
						error={!!errors.first_name}
					/>

					<Form.Input
						placeholder={translate("xxltable.step2.last_name")}
						icon="user"
						iconPosition="left"
						name="last_name"
						value={data.last_name}
						onChange={this.onChange.bind(this)}
						error={!!errors.last_name}
					/>
				</Form.Group>

				<Form.Group widths="equal">
					<Popup
						ref="birthdayPopup"
						trigger={
							<Form.Input
								placeholder={translate("xxltable.step2.birthday")}
								icon="calendar"
								iconPosition="left"
								name={'crypto_'+CryptoJS.AES.encrypt("birthday", this.form_field_key).toString()}
								value={data.birthday}
								onChange={this.onChange.bind(this)}
								error={!!errors.birthday}
								onClick={this.openPopup.bind(this)}
							/>
						}
						on='click'
						position='bottom left'
						open={this.state.isOpen}
						onClose={this.onPopupClose.bind(this)}
					>
						<DayPicker
							canChangeMonth={false}
							month={this.state.month}
							selectedDays={data.birthday_u === "" ? moment().toDate() : moment(data.birthday_u).toDate()}
							fromMonth={fromMonth}
							toMonth={toMonth}
							onDayClick={this.onDateChange.bind(this)}
							captionElement={({ date, localeUtils }) => (
								<YearMonthForm
									date={date}
									localeUtils={localeUtils}
									onChange={this.handleYearMonthChange}
								/>
							)}
						/>
					</Popup>
				</Form.Group>

				<Form.Group widths="equal">
					<Form.Input
						placeholder={translate("xxltable.step2.address")}
						icon="home"
						iconPosition="left"
						name="address"
						value={data.address}
						onChange={this.onChange.bind(this)}
						error={!!errors.address}
					/>

					<Form.Input
						placeholder={translate("xxltable.step2.zip_code")}
						icon="home"
						iconPosition="left"
						name="zip_code"
						value={data.zip_code}
						onChange={this.onChange.bind(this)}
						error={!!errors.zip_code}
					/>

					<Form.Input
						placeholder={translate("xxltable.step2.city")}
						icon="home"
						iconPosition="left"
						name="city"
						value={data.city}
						onChange={this.onChange.bind(this)}
						error={!!errors.city}
					/>

					<Form.Field>
						<Dropdown
							placeholder={translate("xxltable.step2.country")}
							fluid
							search
							selection
							options={countries}
							value={data.country}
							onChange={this.onChangeCountry.bind(this)}
							error={!!errors.country}
						/>
					</Form.Field>
				</Form.Group>

				<Form.Group widths="equal">
					<Form.Input
						placeholder={translate("xxltable.step2.email")}
						icon="mail"
						iconPosition="left"
						name="email"
						value={data.email}
						onChange={this.onChange.bind(this)}
						error={!!errors.email}
					/>
				</Form.Group>


				<div className="ui center aligned container">
					<Form.Button positive>{translate("xxltable.step2.btn_next")}</Form.Button>
				</div>
			</Form>
		);
	}
}

export default VerifyPhoneForm;


// WEBPACK FOOTER //
// ./src/components/forms/PersonalInfoForm.js